import { z } from 'zod';

export const strategicImperativeSchema = z.object({
  title: z.string(),
  description: z.string(),
  subStrategies: z.array(z.string()),
});

const brandLookupSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  displayName: z.string().nullable(),
});

const brandDrugClassProductBrandMappingSchema = z.object({
  drugClass: brandLookupSchema,
  productBrands: z.array(brandLookupSchema),
});

export const brandDetailsSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  displayName: z.string(),
  name: z.string(),
  genericNames: z.array(z.string()),
  // description: Remirror.RemirrorSchema.RootNode,
  synonyms: z.array(z.string()),
  strategicImperatives: z.array(strategicImperativeSchema),
  salesDirections: z.string().array(),
  munTargets: z.string().array(),
  access: z.string().optional(),
  groupId: z.number(),
  productBrand: brandLookupSchema.nullable().optional(),
  indication: brandLookupSchema.nullable().optional(),
  therapeuticArea: brandLookupSchema.nullable().optional(),
  productBrands: brandLookupSchema.array().optional(),
  drugClasses: brandLookupSchema.array().optional(),
  genericDrugs: brandLookupSchema.array().optional(),
  drugClassProductBrandMappings: z.array(brandDrugClassProductBrandMappingSchema).optional(),
});
export type BrandDetails = z.infer<typeof brandDetailsSchema>;
